export var ParticipantStepState;
(function (ParticipantStepState) {
    ParticipantStepState["PENDING"] = "PENDING";
    ParticipantStepState["RUNNING"] = "RUNNING";
    ParticipantStepState["COMPLETED"] = "COMPLETED";
    ParticipantStepState["SKIPPED"] = "SKIPPED";
    ParticipantStepState["CONFIRMED"] = "CONFIRMED";
    ParticipantStepState["REJECTED"] = "REJECTED";
    ParticipantStepState["OVERDUE"] = "OVERDUE";
    ParticipantStepState["FAILED"] = "FAILED";
})(ParticipantStepState || (ParticipantStepState = {}));
export var State;
(function (State) {
    State["JOIN_REQUESTED"] = "JOIN_REQUESTED";
    State["INVITED"] = "INVITED";
    State["JOIN_REJECTED"] = "JOIN_REJECTED";
    State["PAYMENT_REQUESTED"] = "PAYMENT_REQUESTED";
    State["PAYMENT_STARTED"] = "PAYMENT_STARTED";
    State["JOINED"] = "JOINED";
    State["LEFT"] = "LEFT";
    State["REMOVED"] = "REMOVED";
    State["RUNNING"] = "RUNNING";
    State["COMPLETED"] = "COMPLETED";
    State["FAILED"] = "FAILED";
    State["PAYMENT_STARTED_OFFLINE"] = "PAYMENT_STARTED_OFFLINE";
    State["SUSPENDED"] = "SUSPENDED";
    State["AUTO_REMOVED"] = "AUTO_REMOVED";
})(State || (State = {}));
export var ParticipationState;
(function (ParticipationState) {
    ParticipationState["NotStarted"] = "NotStarted";
    ParticipationState["InProgress"] = "InProgress";
    ParticipationState["Finished"] = "Finished";
    ParticipationState["Suspended"] = "Suspended";
    ParticipationState["AutoRemoved"] = "AutoRemoved";
})(ParticipationState || (ParticipationState = {}));
export var QueryParticipantsRequestJoinPath;
(function (QueryParticipantsRequestJoinPath) {
    QueryParticipantsRequestJoinPath["UNKNOWN_JOIN_PATH"] = "UNKNOWN_JOIN_PATH";
    QueryParticipantsRequestJoinPath["FREE"] = "FREE";
    QueryParticipantsRequestJoinPath["ADDED"] = "ADDED";
    QueryParticipantsRequestJoinPath["SINGLE_PAYMENT"] = "SINGLE_PAYMENT";
    QueryParticipantsRequestJoinPath["PAID_PLAN"] = "PAID_PLAN";
})(QueryParticipantsRequestJoinPath || (QueryParticipantsRequestJoinPath = {}));
export var QueryParticipantsRequestSortingCriterion;
(function (QueryParticipantsRequestSortingCriterion) {
    QueryParticipantsRequestSortingCriterion["DEFAULT"] = "DEFAULT";
    QueryParticipantsRequestSortingCriterion["JOIN_DATE"] = "JOIN_DATE";
    QueryParticipantsRequestSortingCriterion["NAME"] = "NAME";
    QueryParticipantsRequestSortingCriterion["LAST_EVENT"] = "LAST_EVENT";
    QueryParticipantsRequestSortingCriterion["PERFORMANCE"] = "PERFORMANCE";
})(QueryParticipantsRequestSortingCriterion || (QueryParticipantsRequestSortingCriterion = {}));
export var QueryParticipantsRequestSortingOrder;
(function (QueryParticipantsRequestSortingOrder) {
    QueryParticipantsRequestSortingOrder["ORDER_DEFAULT"] = "ORDER_DEFAULT";
    QueryParticipantsRequestSortingOrder["ORDER_ASC"] = "ORDER_ASC";
    QueryParticipantsRequestSortingOrder["ORDER_DESC"] = "ORDER_DESC";
})(QueryParticipantsRequestSortingOrder || (QueryParticipantsRequestSortingOrder = {}));
export var SortingCriterion;
(function (SortingCriterion) {
    SortingCriterion["DEFAULT"] = "DEFAULT";
    SortingCriterion["JOIN_DATE"] = "JOIN_DATE";
    SortingCriterion["NAME"] = "NAME";
    SortingCriterion["LAST_EVENT"] = "LAST_EVENT";
    SortingCriterion["PERFORMANCE"] = "PERFORMANCE";
})(SortingCriterion || (SortingCriterion = {}));
export var SortingOrder;
(function (SortingOrder) {
    SortingOrder["ORDER_DEFAULT"] = "ORDER_DEFAULT";
    SortingOrder["ORDER_ASC"] = "ORDER_ASC";
    SortingOrder["ORDER_DESC"] = "ORDER_DESC";
})(SortingOrder || (SortingOrder = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["SINGLE_PAYMENT"] = "SINGLE_PAYMENT";
    PaymentType["PAID_PLANS"] = "PAID_PLANS";
})(PaymentType || (PaymentType = {}));
export var DescriptionFieldSet;
(function (DescriptionFieldSet) {
    /** title and detailed description. */
    DescriptionFieldSet["EXTENDED"] = "EXTENDED";
    /** title only. */
    DescriptionFieldSet["STANDARD"] = "STANDARD";
})(DescriptionFieldSet || (DescriptionFieldSet = {}));
export var ChoiceRightness;
(function (ChoiceRightness) {
    ChoiceRightness["NEUTRAL"] = "NEUTRAL";
    ChoiceRightness["RIGHT"] = "RIGHT";
    ChoiceRightness["WRONG"] = "WRONG";
})(ChoiceRightness || (ChoiceRightness = {}));
export var QuizType;
(function (QuizType) {
    QuizType["QUIZ"] = "QUIZ";
    QuizType["QUESTIONNAIRE"] = "QUESTIONNAIRE";
})(QuizType || (QuizType = {}));
export var DurationUnit;
(function (DurationUnit) {
    DurationUnit["WEEKS"] = "WEEKS";
    DurationUnit["DAYS"] = "DAYS";
    DurationUnit["HOURS"] = "HOURS";
    DurationUnit["MINUTES"] = "MINUTES";
})(DurationUnit || (DurationUnit = {}));
export var ResolutionStatus;
(function (ResolutionStatus) {
    ResolutionStatus["COMPLETED"] = "COMPLETED";
    ResolutionStatus["SKIPPED"] = "SKIPPED";
    ResolutionStatus["UNDO"] = "UNDO";
    ResolutionStatus["QUIZ_SUBMIT"] = "QUIZ_SUBMIT";
})(ResolutionStatus || (ResolutionStatus = {}));
export var Status;
(function (Status) {
    /** step completed */
    Status["COMPLETED"] = "COMPLETED";
    /** participant failed to resolve step */
    Status["FAILED"] = "FAILED";
})(Status || (Status = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map